import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
 
import { Alert, AlertType } from '../models/alert';
 
@Injectable()
export class AlertService {

     constructor(private router: Router) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert messages
                    this.clear();
                }
            }
        });
    }

    private subject = new Subject<Alert>();
    private keepAfterRouteChange = false;
 
    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }
 
    success(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Success, message, keepAfterRouteChange);
    }
 
    error(message: string, options?: any) {
        debugger;
        this.alert(AlertType.Error, message, options);
    }
 
    info(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Info, message, keepAfterRouteChange);
    }
 
    warn(message: string, keepAfterRouteChange = false) {
        this.alert(AlertType.Warning, message, keepAfterRouteChange);
    }
 
    alert(type: AlertType, message: string, options?: any) {
        options = options || {};
        options.type = type;
        options.message = message;

        var alert = new Alert(options);

        this.keepAfterRouteChange = options.keepAfterRouteChange;
        this.subject.next(alert);
        setTimeout(() => {
            this.clear();
        }, 4000)
    }
 
    clear() {
        // clear alerts
        var alert = new Alert(null);

        this.subject.next(alert);
    }
}
